import React from "react";
import { MdCheck } from "react-icons/md";

function Plan({ title, desc, price, year, data, color, message, link }) {
  return (
    <div>
      <div className="shadow-lg max-w-sm lg:w-full rounded-2xl bg-white p-8 grid gap-5">
        <p className="text-gray-600 text-xl font-medium">{title}</p>
        {price >= 0 && <p className="text-gray-900 text-3xl font-bold">
          ${price}
          {year ? 
            <span className="text-gray-300 text-sm">/ year</span> : 
            <span className="text-gray-300 text-sm">/ month</span>
          }
        </p>}
        <p className="text-gray-600 text-md">{desc}.</p>
        <hr />
        <ul className="flex flex-col gap-5">
          {data.map((row, key) => {
            return (
              <li key={key}>
                <div className="flex items-center gap-3">
                  <div className={"text-white p-1 rounded-full " + color}>
                    <MdCheck />
                  </div>
                  <p className="font-medium">{row}</p>
                </div>
              </li>
            );
          })}
        </ul>
        {message && 
          <a
            type="button"
            className={"py-2.5 px-4 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg " + color}
            href={link}
            target="_blank"    
          >
            {message}
          </a>}
      </div>
    </div>
  );
}

export default Plan;
